import { render, staticRenderFns } from "./user-form-component.vue?vue&type=template&id=4c378330&scoped=true&"
import script from "./user-form-component.vue?vue&type=script&lang=js&"
export * from "./user-form-component.vue?vue&type=script&lang=js&"
import style0 from "./user-form-component.vue?vue&type=style&index=0&id=4c378330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c378330",
  null
  
)

export default component.exports